import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Onboarding from "./pages/Onboarding";
import PublicReceptionist from "./pages/PublicReceptionist";
import PaymentSuccess from "./pages/PaymentSuccess";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import DataDeletion from "./pages/DataDeletion";
import AuthCallback from "./pages/AuthCallback";
import GoogleCallback from "./pages/GoogleCallback";
import DashboardLayout from "./components/DashboardLayout";
import Overview from "./pages/dashboard/Overview";
import Leads from "./pages/dashboard/Leads";
import Bookings from "./pages/dashboard/Bookings";
import Calendar from "./pages/dashboard/Calendar";
import Invoices from "./pages/dashboard/Invoices";
import Receptionist from "./pages/dashboard/Receptionist";
import Connect from "./pages/dashboard/Connect";
import Prices from "./pages/dashboard/Prices";
import Billing from "./pages/dashboard/Billing";
import Settings from "./pages/dashboard/Settings";
import Members from "./pages/dashboard/Members";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/c/:slug" element={<PublicReceptionist />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/data-deletion" element={<DataDeletion />} />
      <Route path="/auth/google" element={<GoogleCallback />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<Overview />} />
        <Route path="leads" element={<Leads />} />
        <Route path="bookings" element={<Bookings />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="invoices" element={<Invoices />} />
        <Route path="receptionist" element={<Receptionist />} />
        <Route path="connect" element={<Connect />} />
        <Route path="prices" element={<Prices />} />
        <Route path="billing" element={<Billing />} />
        <Route path="settings" element={<Settings />} />
        <Route path="members" element={<Members />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
